import React, { Component, ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  padding: 20px;
  margin: 20px;
  border: 1px solid #ff4444;
  border-radius: 4px;
  background-color: #ffebee;
  color: #c62828;
`;

const ErrorTitle = styled.h2`
  margin-bottom: 10px;
  color: #c62828;
`;

const ErrorMessage = styled.p`
  margin-bottom: 15px;
  color: #c62828;
`;

const ReloadButton = styled.button`
  padding: 8px 16px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #1976d2;
  }
`;

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Erreur capturée par ErrorBoundary:', error, errorInfo);
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorTitle>Oups ! Quelque chose s'est mal passé</ErrorTitle>
          <ErrorMessage>
            {this.state.error?.message || 'Une erreur inattendue est survenue'}
          </ErrorMessage>
          <ReloadButton onClick={this.handleReload}>
            Recharger l'application
          </ReloadButton>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

